//  target blank script
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// 
function abzQuantity(btn, selector) {
  if (!btn) return;
  if (!selector || typeof selector != 'string') return;
  btn.value && btn.value > 0 && (document.querySelector(selector).value = btn.value);

  let priceBtn = document.querySelector('.main-price-btn');
  (btn.dataset.qp && priceBtn) ? priceBtn.innerText = btn.dataset.qp : "";
}

// 
